export default __webpack_public_path__ + "static/thumbnail-de344d4c19dee630c989c1fcfc5d1302.jpg";